import {springEndPoint} from '../../config';
//import auth from '../../modules/auth';

const host = springEndPoint.host;

class supplierApi {
    static getSuppliers(token) {
        return fetch(`${host}/supplier/listall`, {
            headers: {
                Authorization: `Bearer ` + localStorage._token,
                loginId: atob(localStorage._userId),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'GET'
        })
            .then((response) => response.json())
            .then((json) => json)
            .catch((err) => err);
    }
    static createSupplier(supplierData,token) {
        return fetch(`${host}/supplier/add`, {
            headers: {
                Authorization: `Bearer ` + localStorage._token,
                loginId: atob(localStorage._userId),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(supplierData)
        })
            .then((response) => response.json())
            .then((json) => json)
            .catch((err) => err);
    }
    static updateSupplier(supplierID, supplierData,token) {
        return fetch(`${host}/supplier/update/${supplierID}`, {
            headers: {
                Authorization: `Bearer ` + localStorage._token,
                loginId: atob(localStorage._userId),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(supplierData)
        })
            .then((response) => response.json())
            .then((json) => json)
            .catch((err) => err);
    }
    static deleteSupplier(deleteId,token) {
        return fetch(`${host}/supplier/delete/${deleteId}`, {
            headers: {
                Authorization: `Bearer ` + localStorage._token,
                loginId: atob(localStorage._userId),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'DELETE'
        })
            .then((response) => response.json())
            .then((json) => json)
            .catch((err) => err);
    }
    static getSupplierbyID(supplierID, token) {
        return fetch(`${host}/supplier/getSupplier/${supplierID}`, {
            headers: {
                Authorization: `Bearer ` + localStorage._token,
                loginId: atob(localStorage._userId),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'GET'
        })
            .then((response) => response.json())
            .then((json) => json)
            .catch((err) => err);
    }
}

export default supplierApi;